<template>
  <div class="puzzle-image-by-grid" v-show="isGrid">
    <div class="edit-form">
      <span class="label">每行图片数</span>
      <el-input v-model="column" placeholder="请输入..." @keyup.enter.native="apply" size="mini"></el-input>
    </div>
    <span class="error-text">{{ errorText }}</span>
  </div>
</template>

<script>
export default {
  props: {
    isGrid: {
      type: Boolean,
      default: false
    },
    selectedInstance: {
      type: Array,
      default: []
    },
    innerGap: {
      type: Number,
      default: 0
    },
    outerMargin: {
      type: Number,
      default: 0
    },
    strokeColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      column: '',
      errorText: '',
      canvas: null,
      ctx: null
    }
  },
  watch: {
    'selectedInstance.length'() {
      if (this.isGrid && this.column) {
        this.apply();
      }
    },
    'column'() {
      if (this.isGrid) {
        this.validateInput();
      }
    },
    'innerGap'() {
      if (this.isGrid && this.column && this.selectedInstance.length > 1) {
        this.apply();
      }
    },
    'outerMargin'() {
      if (this.isGrid && this.column) {
        this.apply();
      }
    },
    'strokeColor'() {
      if (this.isGrid && this.column) {
        this.apply();
      }
    },
  },
  methods: {
    apply () {
      if (!this.selectedInstance.length) {
        this.$message({
          type: 'error',
          message: '请选中需要操作的图片'
        })
        return;
      }
      if (!this.column) {
        this.$message({
          type: 'error',
          message: '宫格行列数不能为空'
        })
        return;
      }

      const testColumn = this.validateInput();
      testColumn && this.combineImages();
    },

    // 合成图片
    async combineImages() {
      if (!this.canvas) {
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');
      }

      // 计算行列数
      const columns = this.selectedInstance.length <= 8 ? this.column : Math.min(this.column, this.selectedInstance.length);
      const rows = Math.ceil(this.selectedInstance.length / columns);

      // 计算画布尺寸（包含边距）
      const cellSize = 200;
      const canvasWidth = columns * cellSize + (columns - 1) * this.innerGap + 2 * this.outerMargin;
      const canvasHeight = rows * cellSize + (rows - 1) * this.innerGap + 2 * this.outerMargin;

      // 初始化画布
      this.canvas.width = canvasWidth;
      this.canvas.height = canvasHeight;
      this.ctx.fillStyle = this.strokeColor;
      this.ctx.fillRect(0, 0, canvasWidth, canvasHeight);

      const images = this.selectedInstance.map(item => item.img);
      // 绘制所有图片
      images.forEach((imgEl, index) => {
        // 计算位置（包含边距偏移）
        const col = index % columns;
        const row = Math.floor(index / columns);

        const x = this.outerMargin + col * (cellSize + this.innerGap);
        const y = this.outerMargin + row * (cellSize + this.innerGap);

        // 创建临时Canvas处理图片
        const tempCanvas = this.processImage(imgEl, cellSize);

        // 绘制图片
        this.ctx.drawImage(tempCanvas, x, y);
      });

      // 生成预览图
      this.$emit('changeCurrentPuzzleImage', this.canvas.toDataURL('image/png'));
    },

    // 图片处理函数（封装裁剪逻辑）
    processImage(imgEl, targetSize) {
      const scale = Math.max(targetSize / imgEl.naturalWidth, targetSize / imgEl.naturalHeight);

      const scaledWidth = imgEl.naturalWidth * scale;
      const scaledHeight = imgEl.naturalHeight * scale;

      // 缩放Canvas
      const scaleCanvas = document.createElement('canvas');
      scaleCanvas.width = scaledWidth;
      scaleCanvas.height = scaledHeight;
      const scaleCtx = scaleCanvas.getContext('2d');
      scaleCtx.drawImage(imgEl, 0, 0, scaledWidth, scaledHeight);

      // 裁剪Canvas
      const cropCanvas = document.createElement('canvas');
      cropCanvas.width = targetSize;
      cropCanvas.height = targetSize;
      const cropCtx = cropCanvas.getContext('2d');

      // 居中裁剪
      cropCtx.drawImage(
        scaleCanvas,
        (scaledWidth - targetSize) / 2,
        (scaledHeight - targetSize) / 2,
        targetSize,
        targetSize,
        0,
        0,
        targetSize,
        targetSize
      )

      return cropCanvas;
    },

    // todo
    imageContain () {
      var canvas = document.getElementById('canvas');
      var ctx = canvas.getContext('2d');
      var img = new Image();
      img.src = "images/pic1.jpg";
      let dx, dy, dw, dh, imgRatio, canvasRatio;
      canvasRatio = canvas.width / canvas.height;

      // contain 方式
      img.onload = function () {
        imgRatio = img.width / img.height;
        if (imgRatio <= canvasRatio) {
          dw = imgRatio * canvas.width
          dh = canvas.height
          dx = (canvas.width - dw) / 2
          dy = 0
        } else {
          dw = canvas.width
          dh = dw / imgRatio
          dx = 0
          dy = (canvas.height - dh) / 2 
        }
        ctx.drawImage(img, dx, dy, dw, dh)
      }
    },

    imageCover () {
      var canvas = document.getElementById('canvas');
      var ctx = canvas.getContext('2d');
      var img = new Image();
      img.src = "images/pic1.jpg";
      let sx, sy, sw, sh, imgRatio, canvasRatio;
      canvasRatio = canvas.width / canvas.height;
      // cover 方式
      img.onload = function () {
        imgRatio = img.width / img.height;
        if (imgRatio <= canvasRatio){
          sw = img.width
          sh = sw / canvasRatio
          sx = 0
          sy = (img.height - sh) / 2
        } else { 
          sh = img.height 
          sw = sh * canvasRatio
          sx = (img.width - sw) / 2
          sy = 0
        } 
        ctx.drawImage(img, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height) // 因为是cover覆盖， 所以dx,dy都是0，绘制宽高即为canvas宽高 }
      }
    },

    validateInput() {
      if (this.column) {
        if (!/^\d+$/.test(this.column)) {
          this.errorText = '请输入正整数';
          return false;
        } else if (+this.column > 8 || +this.column < 1) {
          this.errorText = '每行图片数应大于1或小于8';
          return false;
        } else {
          return true;
        }
      } else {
        this.errorText = '';
        return false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.puzzle-image-by-grid {
  font-size: 13px;
  .edit-form {
    display: flex;
    gap: 10px;
    margin-bottom: 5px;
    .label {
      flex: 0 0 65px;
      line-height: 28px;
    }
  }

  .error-text {
    color: #dc2727;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/images/puzzle/puzzleImageByGrid/index.vue